export default class TestProjectBaseline {
    id: string;
    testProjectId: string;
    packageId: string;
    topicId: string;
    value: string;
    fuzzy: number;
}
